// extracted by mini-css-extract-plugin
export default {"wrapper":"Goals_wrapper__8kP3p","list":"Goals_list__ZQBVv","stubWrapper":"Goals_stubWrapper__xrnLa","textarea":"Goals_textarea__k203q"};